export const CONNECTION_STATUS = {
    requested: '0',
    accepted: '1',
    rejected: '2',
    deleted: '3',
};
